import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionLevel } from './competition-level'
import { CompetitionLevelSerializer } from './competition-level.serializer'

@Injectable()
export class CompetitionLevelService extends ResourceService<CompetitionLevel> {
  constructor(
    private http: HttpClient,
    private competitionLevelSerializer: CompetitionLevelSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-levels`,
      competitionLevelSerializer
    )
  }
}
